import {
  DashboardSummaryCard,
  DashboardUnits,
} from '@dataTypes/dashboard.types'
import { AxisModel } from '@syncfusion/ej2-charts'

export const perfBoardCards: DashboardSummaryCard = [
  {
    title: 'Active Patients',
    activeCount: 3056,
    trend: 'increase',
  },
  {
    title: 'Active Hygiene Patients',
    activeCount: 2856,
    trend: 'increase',
  },
  {
    title: "Prior Day's Prod",
    activeCount: 33056,
    trend: 'decrease',
  },
]

export const seriesNamesVisits = ['Goal', 'Scheduled', 'Completed', 'Broken']
export const colors = ['#3991EF', '#4CA3FF', '#0061f2', '#0961BF']

export const visitData = [
  { xValue: '10/02', Scheduled: 60, Completed: 55, Goal: 50, Broken: 55 },
  { xValue: '10/03', Scheduled: 48, Completed: 50, Goal: 55, Broken: 55 },
  { xValue: '10/04', Scheduled: 58, Completed: 45, Goal: 52, Broken: 55 },
  { xValue: '10/05', Scheduled: 64, Completed: 60, Goal: 55, Broken: 55 },
  { xValue: '10/06', Scheduled: 52, Completed: 47, Goal: 55, Broken: 55 },
  { xValue: '10/07', Scheduled: 62, Completed: 55, Goal: 45, Broken: 55 },
  { xValue: '10/08', Scheduled: 65, Completed: 60, Goal: 58, Broken: 55 },
]

export const cardLegendData = [
  {
    name: 'Goal',
    value: 100,
    showCurrency: false,
  },
  {
    name: 'Scheduled',
    value: 200,
    showCurrency: false,
  },
  {
    name: 'Completed',
    value: 40,
    showCurrency: false,
  },
  {
    name: 'Broken',
    value: 10,
    showCurrency: false,
  },
]

export const seriesNamesProduction = [
  'Goal',
  'Scheduled',
  'Gross',
  'Adjustment',
]

export const seriesNamesLineProduction = ['Net']
export const colorsLine = ['#4CA3FF']

export const productiontColumnData = [
  { xValue: '10/02', Scheduled: 45, Gross: 45, Goal: 45, Adjustment: 45 },
  { xValue: '10/03', Scheduled: 40, Gross: 40, Goal: 40, Adjustment: 40 },
  { xValue: '10/04', Scheduled: 50, Gross: 50, Goal: 50, Adjustment: 50 },
  { xValue: '10/05', Scheduled: 40, Gross: 40, Goal: 40, Adjustment: 40 },
  { xValue: '10/06', Scheduled: 40, Gross: 40, Goal: 40, Adjustment: 40 },
  { xValue: '10/07', Scheduled: 43, Gross: 43, Goal: 43, Adjustment: 43 },
  { xValue: '10/08', Scheduled: 65, Gross: 65, Goal: 65, Adjustment: 65 },
]

export const productiontLineData = [
  { xValue: '10/02', Net: 45 },
  { xValue: '10/03', Net: 40 },
  { xValue: '10/04', Net: 50 },
  { xValue: '10/05', Net: 40 },
  { xValue: '10/06', Net: 40 },
  { xValue: '10/07', Net: 43 },
  { xValue: '10/08', Net: 65 },
]

export const cardLegendDataProd = [
  {
    name: 'Goal',
    value: 1000,
    showCurrency: true,
  },
  {
    name: 'Scheduled',
    value: 2000,
    showCurrency: true,
  },
  {
    name: 'Gross',
    value: 4000,
    showCurrency: true,
  },
  {
    name: 'Adjustment',
    value: 10000,
    showCurrency: true,
  },
  {
    name: 'Net',
    value: 10000,
    showCurrency: true,
  },
]

// export const unscheduledPatPC = [
//   { x: 'A', y: 20, color: '#003E56' },
//   { x: 'B', y: 10, color: '#00cfd5' },
//   { x: 'C', y: 10, color: '#0061f2' },
//   { x: 'D', y: 25, color: '#00B4FB' },
//   { x: 'E', y: 15, color: '#C6DFED' },
//   { x: 'F', y: 20, color: '#ABC3D1' },
// ]

// export const unscheduledPatPC = [
//   { x: 'Unscheduled Active Patients', y: 20, color: '#003E56' },
//   { x: 'Unscheduled Opportunity', y: 10, color: '#00cfd5' },
//   { x: 'Annual Opportunity', y: 10, color: '#0061f2' },
//   { x: 'Rescheduled Patients', y: 25, color: '#00B4FB' },
//   { x: 'Rescheduled Production', y: 15, color: '#C6DFED' },
//   { x: 'Annual Production', y: 20, color: '#ABC3D1' },
// ]

export const unscheduledPatPC = [
  {
    x: 'Unscheduled Active Patients',
    y: 20,
    name: `20`,
    color: '#3991EF',
  },
  { x: 'Unscheduled Opportunity', y: 10, name: `10`, color: '#006FE6' },
  { x: 'Annual Opportunity', y: 10, name: `10`, color: '#007BFF' },
  { x: 'Rescheduled Patients', y: 25, name: `25`, color: '#1A88FF' },
  { x: 'Rescheduled Production', y: 15, name: `15`, color: '#3396FF' },
  { x: 'Annual Production', y: 20, name: `20`, color: '#4CA3FF' },
]

export const unschedPatPCLegend = [
  {
    name: 'Unscheduled Active Patients',
    value: 800,
    showCurrency: false,
  },
  {
    name: 'Unscheduled Opportunity',
    value: 1800,
    showCurrency: true,
  },
  {
    name: 'Annual Opportunity (Est.)',
    value: 80000,
    showCurrency: true,
  },
  {
    name: 'Rescheduled Patients',
    value: 8,
    showCurrency: false,
  },
  {
    name: 'Rescheduled Production',
    value: 2800,
    showCurrency: true,
  },
  {
    name: 'Annual Production (Est.)',
    value: 8000,
    showCurrency: true,
  },
]

// Restorative/Elective Case

export const restorativeCase = {
  goal: 300,
  actual: 150,
  unit: '%',
  diagnostic: {
    goal: 42,
    actual: 42,
    unit: '%',
  },
  acceptance: {
    goal: 65,
    actual: 75,
    unit: '%',
  },
}

export const hygieneCase = {
  goal: 300,
  actual: 150,
  unit: '$',
  diagnostic: {
    goal: 42,
    actual: 42,
    unit: '%',
  },
  acceptance: {
    goal: 65,
    actual: 75,
    unit: '%',
  },
}

export const newPatients = {
  goal: 30,
  actual: 18,
  unit: '#',
  diagnostic: {
    goal: 42,
    actual: 42,
    unit: '%',
  },
  acceptance: {
    goal: 65,
    actual: 75,
    unit: '%',
  },
}

export const diagnostic = {
  label: 'Diagnostic',
  goal: 42,
  actual: 42,
}

export const acceptance = {
  label: 'Acceptance',
  goal: 65,
  actual: 78,
}

export const newPatientsLegend = [
  {
    name: 'New',
    value: 19,
    showCurrency: false,
  },
  {
    name: 'Recaptured',
    value: 21,
    showCurrency: false,
  },
  {
    name: 'Lost',
    value: 45,
    showCurrency: false,
  },
  {
    name: 'growth',
    value: -8,
    showCurrency: false,
  },
]

export const hygieneReappointmentLegend = [
  {
    name: 'Visits',
    value: 49,
    showCurrency: false,
  },
  {
    name: 'Re-Appointed',
    value: 41,
    showCurrency: false,
  },
  {
    name: 'Unscheduled',
    value: 6,
    showCurrency: false,
  },
]

export const CancellationsLegend = [
  {
    name: 'Visits',
    value: 49,
    showCurrency: false,
  },
  {
    name: 'Cancelled',
    value: 41,
    showCurrency: false,
  },
  {
    name: 'Unscheduled',
    value: 6,
    showCurrency: false,
  },
]

export const noShowsLegend = [
  {
    name: 'Visits',
    value: 49,
    showCurrency: false,
  },
  {
    name: 'No-Shows',
    value: 41,
    showCurrency: false,
  },
  {
    name: 'Unscheduled',
    value: 6,
    showCurrency: false,
  },
]

export const radioBtn = [
  {
    field: 'all',
    title: 'All',
  },
  {
    field: 'accepted',
    title: 'Accepted',
  },
]

export const radioBtn2 = [
  {
    field: 'total',
    title: 'Total',
  },
  {
    field: 'average',
    title: 'Average',
  },
]

export const patientsData = [
  {
    label: 'Presented',
    value: 1000,
    unit: '$',
  },
  {
    label: 'Accepted',
    value: 2000,
    unit: '$',
  },
  {
    label: 'Accepted (%)',
    value: 43,
    unit: '%',
  },
]

export const progressBarData = {
  goal: 300,
  actual: 200,
  unit: '%' as DashboardUnits,
}
// Morning huddle - YESTERDAY
export const prodData = [
  { x: 'Hygienist', y: 3.0, color: '#4CA3FF' },
  { x: 'Dentist', y: 3.0, color: '#006FE6' },
]

export const prodDataBodyTitle = {
  goal: 20000,
  actual: 10000,
  unit: '$' as DashboardUnits,
}

export const hygieneData = [
  { x: 'New Patients', y: 1, color: '#4CA3FF' },
  { x: 'Reappointed', y: 4, color: '#006FE6' },
]

export const hygieneDataBodyTitle = {
  goal: 50,
  actual: 40,
  unit: '%' as DashboardUnits,
}

export const hygieneDataPrimaryYAxis: AxisModel = {
  minimum: 0,
  maximum: 4,
  interval: 1,
}

export const collectionData = {
  goal: 10000,
  actual: 15300,
  unit: '$',
}

export const dentistProdData = {
  goal: 1700,
  actual: 1300,
  unit: '$',
}

export const txAcceptanceData = [
  { x: 'Presented', y: 1000, color: '#4CA3FF' },
  { x: 'Accepted', y: 4000, color: '#006FE6' },
]

export const txAcceptanceDataYAxis: AxisModel = {
  minimum: 0,
  maximum: 4000,
  interval: 1000,
}

export const txAcceptanceDataBodyTitle = {
  goal: 37,
  actual: 3.37,
  unit: '%' as DashboardUnits,
}

export const priorTxAccepted = [{ x: '10/11', y: 4000, color: '#006FE6' }]

export const priorTxAcceptedDataYAxis: AxisModel = {
  minimum: 0,
  maximum: 4000,
  interval: 1000,
}

export const priorTxAcceptedBodyTitle = {
  goal: 7000,
  actual: 0,
  unit: '$' as DashboardUnits,
}

// Today

export const todayCard = [
  {
    category: 'unscheduledFamilyMembers',
    value: 15,
    unit: 'count',
    patientCount: '',
  },
  {
    category: 'unscheduledTreatment',
    value: 9500,
    unit: 'currency',
    patientCount: 6,
  },
  {
    category: 'pastDueAR',
    value: 11000,
    unit: 'currency',
    patientCount: 8,
  },
  {
    category: 'unscheduledHygiene',
    value: 9,
    unit: 'count',
    patientCount: 9,
  },
]

export const todayCardConfig = {
  unscheduledFamilyMembers: {
    title: 'Unscheduled Family Members',
    icon: 'bi bi-calendar-x',
    label: 'so far', // Example of customized label
  },
  unscheduledTreatment: {
    title: 'Unscheduled Treatment',
    icon: 'bi bi-clipboard-pulse',
    label: 'patients',
  },
  pastDueAR: {
    title: 'Past Due AR',
    icon: 'bi bi-hourglass',
    label: 'patients',
  },
  unscheduledHygiene: {
    title: 'Unscheduled Hygiene',
    icon: 'bi bi-calendar-heart',
    label: 'patients',
  },
}

export const scheduleByProvider = [
  {
    provider: 'Dr. A',
    appointments: 10,
    hours: '9:00',
    scheduled: 50000,
    completed: 0,
    goal: 7000,
    actual: 1966,
    unscheduledTx: 19000,
  },
  {
    provider: 'Dr. B',
    appointments: 7,
    hours: '9:00',
    scheduled: 50000,
    completed: 0,
    goal: 7000,
    actual: 1966,
    unscheduledTx: 19000,
  },
  {
    provider: 'Dr. C',
    appointments: 5,
    hours: '9:00',
    scheduled: 50000,
    completed: 0,
    goal: 7000,
    actual: 1966,
    unscheduledTx: 19000,
  },
  {
    provider: 'Dr. D',
    appointments: 4,
    hours: '9:00',
    scheduled: 50000,
    completed: 0,
    goal: 7000,
    actual: 1966,
    unscheduledTx: 19000,
  },
  {
    provider: 'Dr. E',
    appointments: 3,
    hours: '9:00',
    scheduled: 50000,
    completed: 0,
    goal: 7000,
    actual: 1966,
    unscheduledTx: 19000,
  },
]

export const scheduleByProviderColumn = [
  {
    field: 'provider',
    header: 'Provider',
  },
  {
    field: 'appointments',
    header: 'Appointments',
  },
  {
    field: 'hours',
    header: 'Hours',
  },
  {
    field: 'scheduled',
    header: 'Scheduled',
  },
  {
    field: 'completed',
    header: 'Completed',
  },
  {
    field: 'goal',
    header: 'Goal',
  },
  {
    field: 'unscheduledTx',
    header: 'Unscheduled Tx',
  },
]

export const scheduleByLocation = [
  {
    location: 'ABC Dental',
    appointments: 10,
    hours: '9:00',
    scheduled: 50000,
    completed: 0,
    goal: 7000,
    actual: 1966,
    unscheduledTx: 19000,
  },
  {
    location: 'XYZ Dental',
    appointments: 7,
    hours: '9:00',
    scheduled: 50000,
    completed: 0,
    goal: 7000,
    actual: 1966,
    unscheduledTx: 19000,
  },
  {
    location: 'Gentle Smiles',
    appointments: 5,
    hours: '9:00',
    scheduled: 50000,
    completed: 0,
    goal: 7000,
    actual: 1966,
    unscheduledTx: 19000,
  },
  {
    location: 'Blue Dental',
    appointments: 4,
    hours: '9:00',
    scheduled: 50000,
    completed: 0,
    goal: 7000,
    actual: 1966,
    unscheduledTx: 19000,
  },
  {
    location: 'Care Dental',
    appointments: 3,
    hours: '9:00',
    scheduled: 50000,
    completed: 0,
    goal: 7000,
    actual: 1966,
    unscheduledTx: 19000,
  },
]

export const scheduleByLocationColumn = [
  {
    field: 'location',
    header: 'Provider',
  },
  {
    field: 'appointments',
    header: 'Appointments',
  },
  {
    field: 'hours',
    header: 'Hours',
  },
  {
    field: 'scheduled',
    header: 'Scheduled',
  },
  {
    field: 'completed',
    header: 'Completed',
  },
  {
    field: 'goal',
    header: 'Goal',
  },
  {
    field: 'unscheduledTx',
    header: 'Unscheduled Tx',
  },
]

// Today

// const todaySideModal = [
//   {
//     patientId: '001',
//     firstName: 'Dana',
//     lastName: 'Oswald',
//     gender: 'female',
//     age: '40',
//     dateOfBirth: '12-03-1982',
//     insurance: 'unverfied',
//     phone: '111222333',
//     email: 'email@email.com',
//     address: '1830 Dover Lane IN, 34563',
//     appointmentId: '001',

//   },
// ]

export const todaySideModal = [
  {
    patientId: '001',
    firstname: 'Dana',
    lastname: 'Oswald',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. A',
  },
  {
    patientId: '002',
    firstname: 'Kasey',
    lastname: 'Dutton',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. B',
  },
  {
    patientId: '003',
    firstname: 'Dana',
    lastname: 'Oswald',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. A',
  },
  {
    patientId: '004',
    firstname: 'Kasey',
    lastname: 'Dutton',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. B',
  },
  {
    patientId: '005',
    firstname: 'Dana',
    lastname: 'Oswald',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. A',
  },
  {
    patientId: '006',
    firstname: 'Kasey',
    lastname: 'Dutton',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. B',
  },
  {
    patientId: '007',
    firstname: 'Dana',
    lastname: 'Oswald',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. A',
  },
  {
    patientId: '008',
    firstname: 'Kasey',
    lastname: 'Dutton',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. B',
  },
  {
    patientId: '009',
    firstname: 'Dana',
    lastname: 'Oswald',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. A',
  },
  {
    patientId: '010',
    firstname: 'Kasey',
    lastname: 'Dutton',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. B',
  },
  {
    patientId: '011',
    firstname: 'Dana',
    lastname: 'Oswald',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. A',
  },
  {
    patientId: '012',
    firstname: 'Kasey',
    lastname: 'Dutton',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. B',
  },
  {
    patientId: '013',
    firstname: 'Dana',
    lastname: 'Oswald',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. A',
  },
  {
    patientId: '014',
    firstname: 'Kasey',
    lastname: 'Dutton',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. B',
  },
  {
    patientId: '015',
    firstname: 'Dana',
    lastname: 'Oswald',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. A',
  },
  {
    patientId: '016',
    firstname: 'Kasey',
    lastname: 'Dutton',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. B',
  },
  {
    patientId: '017',
    firstname: 'Dana',
    lastname: 'Oswald',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. A',
  },
  {
    patientId: '018',
    firstname: 'Kasey',
    lastname: 'Dutton',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. B',
  },
  {
    patientId: '019',
    firstname: 'Dana',
    lastname: 'Oswald',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. A',
  },
  {
    patientId: '020',
    firstname: 'Kasey',
    lastname: 'Dutton',
    startTime: '8:00 AM',
    endTime: '9:00',
    provider: 'Dr. B',
  },
]

export const seriesNamesLB = ['NewPatients', 'Reappointed']
export const colorsLB = ['#4CA3FF', '#006FE6']

export const leaderBoardData = [
  { xValue: '10/02', NewPatients: 100, Reappointed: 90 },
  { xValue: '10/03', NewPatients: 45, Reappointed: 50 },
  { xValue: '10/04', NewPatients: 50, Reappointed: 53 },
  { xValue: '10/05', NewPatients: 49, Reappointed: 50 },
  { xValue: '10/06', NewPatients: 48, Reappointed: 50 },
  { xValue: '10/07', NewPatients: 60, Reappointed: 55 },
  { xValue: '10/08', NewPatients: 65, Reappointed: 65 },
  { xValue: '10/09', NewPatients: 45, Reappointed: 50 },
  { xValue: '10/10', NewPatients: 60, Reappointed: 55 },
  { xValue: '10/11', NewPatients: 47, Reappointed: 50 },
  { xValue: '10/12', NewPatients: 48, Reappointed: 55 },
]

export const LBData = [
  {
    rank: 1,
    provider: 'Dr. A',
    goal: '90%',
    actual: '100%',
  },
  {
    rank: 2,
    provider: 'Dr. B',
    goal: '80%',
    actual: '100%',
  },
  {
    rank: 3,
    provider: 'Dr. C',
    goal: '70%',
    actual: '100%',
  },
  {
    rank: 4,
    provider: 'Dr. D',
    goal: '60%',
    actual: '100%',
  },
  {
    rank: 5,
    provider: 'Dr. E',
    goal: '50%',
    actual: '100%',
  },
]

/* PROVIDER PULSE*/

export const productionData = [
  {
    role: 'General Dentist',
    roleId: 'GD-001',
    production: 40000,
    prevProd: 30000,
    scheduledActual: 30000,
    scheduledGoal: 30000,
    goalScheduled: 87,
    goalComplete: 29,
  },
  {
    role: 'General Dentist',
    roleId: 'GD-001',
    production: 6000,
    prevProd: 30000,
    scheduledActual: 30000,
    scheduledGoal: 30000,
    goalScheduled: 87,
    goalComplete: 29,
  },
  {
    role: 'Hygienist',
    roleId: 'H-001',
    production: 1800,
    prevProd: 30000,
    scheduledActual: 30000,
    scheduledGoal: 30000,
    goalScheduled: 87,
    goalComplete: 29,
  },
  {
    role: 'Hygienist',
    roleId: 'H-001',
    production: 1600,
    prevProd: 30000,
    scheduledActual: 30000,
    scheduledGoal: 30000,
    goalScheduled: 87,
    goalComplete: 29,
  },
  {
    role: 'Hygienist',
    roleId: 'H-001',
    production: 1000,
    prevProd: 30000,
    scheduledActual: 30000,
    scheduledGoal: 30000,
    goalScheduled: 87,
    goalComplete: 29,
  },
]

export const collectionsPPData = [
  {
    role: 'General Dentist',
    roleId: 'GD-001',
    collections: 150000,
    prevCollections: 30000,
    insurance: 30000,
    patients: 30000,
  },
  {
    role: 'General Dentist',
    roleId: 'GD-001',
    collections: 15000,
    prevCollections: 30000,
    insurance: 30000,
    patients: 30000,
  },
  {
    role: 'Hygienist',
    roleId: 'H-001',
    collections: 10000,
    prevCollections: 30000,
    insurance: 30000,
    patients: 30000,
  },
  {
    role: 'General Dentist',
    roleId: 'GD-001',
    collections: 5000,
    prevCollections: 30000,
    insurance: 30000,
    patients: 30000,
  },
  {
    role: 'General Dentist',
    roleId: 'GD-001',
    collections: 4000,
    prevCollections: 30000,
    insurance: 30000,
    patients: 30000,
  },
  {
    role: 'General Dentist',
    roleId: 'GD-001',
    collections: 3000,
    prevCollections: 30000,
    insurance: 30000,
    patients: 30000,
  },
]

export const fluorideTrtmntData = [
  {
    role: 'Hygienist',
    roleId: 'H-001',
    fluorideTreatment: 100,
    prevTreatment: 100,
    totalTreatment: 8,
    totalVisits: 8,
  },
  {
    role: 'Hygienist',
    roleId: 'H-001',
    fluorideTreatment: 90,
    prevTreatment: 100,
    totalTreatment: 8,
    totalVisits: 8,
  },
  {
    role: 'Hygienist',
    roleId: 'H-001',
    fluorideTreatment: 85,
    prevTreatment: 100,
    totalTreatment: 8,
    totalVisits: 8,
  },
  {
    role: 'Hygienist',
    roleId: 'H-001',
    fluorideTreatment: 80,
    prevTreatment: 100,
    totalTreatment: 8,
    totalVisits: 8,
  },
  {
    role: 'Hygienist',
    roleId: 'H-001',
    fluorideTreatment: 75,
    prevTreatment: 100,
    totalTreatment: 8,
    totalVisits: 8,
  },
  {
    role: 'Hygienist',
    roleId: 'H-001',
    fluorideTreatment: 70,
    prevTreatment: 100,
    totalTreatment: 8,
    totalVisits: 8,
  },
]
// Collections Board

export const ARAging = [
  { x: '0-30', y: 300000, color: '#006FE6' },
  { x: '31-60', y: 90000, color: '#4CA3FF' },
  { x: '61-90', y: 80000, color: '#4CA3FF' },
  { x: '90+', y: 250000, color: '#4CA3FF' },
]

export const ClaimsAging = [
  { x: '0-30', y: 300000, color: '#006FE6' },
  { x: '31-60', y: 90000, color: '#4CA3FF' },
  { x: '61-90', y: 80000, color: '#4CA3FF' },
  { x: '90+', y: 250000, color: '#4CA3FF' },
]

export const ClaimsAgingLineData = [
  { xValue: '0-30', y: 300000 },
  { xValue: '31-60', y: 90000 },
  { xValue: '61-90', y: 80000 },
  { xValue: '90+', y: 250000 },
]

export const seriesNamesLineClaimsAging = ['y']

export const ARAgingLegend = [
  {
    name: 'Accounts Receivable',
    value: 500100,
    showCurrency: true,
  },
  {
    name: 'Past Due',
    value: 300100,
    showCurrency: true,
  },
  {
    name: 'Patients Past Due',
    value: 340,
    showCurrency: false,
  },
]

export const ClaimsAgingLegend = [
  {
    name: 'Average Age',
    value: 46,
    showCurrency: false,
  },
  {
    name: 'Claims (Est.)',
    value: 300100,
    showCurrency: true,
  },
  {
    name: 'Past Due',
    value: 34000,
    showCurrency: true,
  },
  {
    name: 'Patients Past Due',
    value: 158,
    showCurrency: false,
  },
]

export const ninetyDayCollection = [
  {
    name: 'Gross Production',
    value: 800800,
    showCurrency: true,
  },
  {
    name: 'Net Production',
    value: 600000,
    showCurrency: true,
  },
  {
    name: 'Collections',
    value: 611000,
    showCurrency: true,
  },
]

export const collectionsLegend = [
  {
    name: 'Collections Adjustment',
    value: 0,
    showCurrency: true,
  },
  {
    name: 'Insurance Collections',
    value: 6000,
    showCurrency: true,
  },
  {
    name: 'Patient Collections',
    value: 6,
    showCurrency: false,
  },
]

export const collectionsData = {
  goal: 35000,
  actual: 17000,
  unit: '$',
}

export const annualPatientValue = {
  goal: 800,
  actual: 1000,
  unit: '$' as DashboardUnits,
  gross: '',
  net: '',
}

export const ninetyDayCollectionPercent = {
  goal: '',
  actual: '',
  unit: '%' as DashboardUnits,
  gross: '83',
  net: '97',
}

export const arDaysCollection = {
  goal: 45,
  actual: 75,
  unit: '#' as DashboardUnits,
  gross: '',
  net: '',
}

export const arRatio = {
  goal: '1.5',
  actual: '2.5:1',
  unit: '' as DashboardUnits,
  gross: '',
  net: '',
}

/* SCORECARDS PAGE*/

export const scoreCardTables = [
  {
    locationId: '001',
    location: 'ABC Dental',
    cancelledAppt: 3,
    newPatSeen: 20,
    noShowAppt: 0,
    appliedPayments: 70.0,
    OTCRate: 10,
    recTXSched: 30.0,
    schedProd: 0.0,
    reSchedAppt: 60,
    rejectRation: 0.0,
  },
  {
    locationId: '002',
    location: 'XYZ Dental',
    cancelledAppt: 3,
    newPatSeen: 20,
    noShowAppt: 0,
    appliedPayments: 70.0,
    OTCRate: 10,
    recTXSched: 30.0,
    schedProd: 0.0,
    reSchedAppt: 60,
    rejectRation: 0.0,
  },
  {
    locationId: '003',
    location: 'Blue Dental',
    cancelledAppt: 3,
    newPatSeen: 20,
    noShowAppt: 0,
    appliedPayments: 70.0,
    OTCRate: 10,
    recTXSched: 30.0,
    schedProd: 0.0,
    reSchedAppt: 60,
    rejectRation: 0.0,
  },
  {
    locationId: '004',
    location: 'Smile Dental',
    cancelledAppt: 3,
    newPatSeen: 20,
    noShowAppt: 0,
    appliedPayments: 70.0,
    OTCRate: 10,
    recTXSched: 30.0,
    schedProd: 0.0,
    reSchedAppt: 60,
    rejectRation: 0.0,
  },
  {
    locationId: '005',
    location: 'Care Dental',
    cancelledAppt: 3,
    newPatSeen: 20,
    noShowAppt: 0,
    appliedPayments: 70.0,
    OTCRate: 10,
    recTXSched: 30.0,
    schedProd: 0.0,
    reSchedAppt: 60,
    rejectRation: 0.0,
  },
  {
    locationId: '006',
    location: 'Green Dental',
    cancelledAppt: 3,
    newPatSeen: 20,
    noShowAppt: 0,
    appliedPayments: 70.0,
    OTCRate: 10,
    recTXSched: 30.0,
    schedProd: 0.0,
    reSchedAppt: 60,
    rejectRation: 0.0,
  },
  {
    locationId: '007',
    location: 'Bright Dental',
    cancelledAppt: 3,
    newPatSeen: 20,
    noShowAppt: 0,
    appliedPayments: 70.0,
    OTCRate: 10,
    recTXSched: 30.0,
    schedProd: 0.0,
    reSchedAppt: 60,
    rejectRation: 0.0,
  },
  {
    locationId: '008',
    location: 'Beta Dental',
    cancelledAppt: 3,
    newPatSeen: 20,
    noShowAppt: 0,
    appliedPayments: 70.0,
    OTCRate: 10,
    recTXSched: 30.0,
    schedProd: 0.0,
    reSchedAppt: 60,
    rejectRation: 0.0,
  },
  {
    locationId: '009',
    location: 'Touch Dental',
    cancelledAppt: 3,
    newPatSeen: 20,
    noShowAppt: 0,
    appliedPayments: 70.0,
    OTCRate: 10,
    recTXSched: 30.0,
    schedProd: 0.0,
    reSchedAppt: 60,
    rejectRation: 0.0,
  },
  {
    locationId: '010',
    location: 'Alpha Dental',
    cancelledAppt: 3,
    newPatSeen: 20,
    noShowAppt: 0,
    appliedPayments: 70.0,
    OTCRate: 10,
    recTXSched: 30.0,
    schedProd: 0.0,
    reSchedAppt: 60,
    rejectRation: 0.0,
  },
]

/* TREND ANALYSIS */

export const trendAnalysisData = {
  collection: [
    {
      kpi: 'Collection Adjustment Rate (TXN)',
      ytd: '0.00%',
      aug: '0.00%',
      jul: '0.00%',
      jun: '0.00%',
      may: '0.00%',
      apr: '0.00%',
      mar: '0.00%',
      feb: '0.00%',
    },
    {
      kpi: 'Insurance Collection Rate (TXN)',
      ytd: '0.00%',
      aug: '0.00%',
      jul: '0.00%',
      jun: '0.00%',
      may: '0.00%',
      apr: '0.00%',
      mar: '0.00%',
      feb: '0.00%',
    },
    {
      kpi: 'Net Collection (Trans. Date)',
      ytd: '$0.00',
      aug: '$0.00',
      jul: '$0.00',
      jun: '$0.00',
      may: '$0.00',
      apr: '$0.00',
      mar: '$0.00',
      feb: '$0.00',
    },
    {
      kpi: 'Net Insurance Collection (Trans. Date)',
      ytd: '$0.00',
      aug: '$0.00',
      jul: '$0.00',
      jun: '$0.00',
      may: '$0.00',
      apr: '$0.00',
      mar: '$0.00',
      feb: '$0.00',
    },
    {
      kpi: 'Net Patient Collection (Trans. Date)',
      ytd: '$0.00',
      aug: '$0.00',
      jul: '$0.00',
      jun: '$0.00',
      may: '$0.00',
      apr: '$0.00',
      mar: '$0.00',
      feb: '$0.00',
    },
    {
      kpi: 'OTC Rate',
      ytd: '0.00%',
      aug: '0.00%',
      jul: '0.00%',
      jun: '0.00%',
      may: '0.00%',
      apr: '0.00%',
      mar: '0.00%',
      feb: '0.00%',
    },
    {
      kpi: 'Patient Collection Rate (TXN)',
      ytd: '0.00%',
      aug: '0.00%',
      jul: '0.00%',
      jun: '0.00%',
      may: '0.00%',
      apr: '0.00%',
      mar: '0.00%',
      feb: '0.00%',
    },
  ],
  production: [
    {
      kpi: 'Net Insurance Production (Trans. Date)',
      ytd: '$0.00',
      aug: '$0.00',
      jul: '$0.00',
      jun: '$0.00',
      may: '$0.00',
      apr: '$0.00',
      mar: '$0.00',
      feb: '$0.00',
    },
    {
      kpi: 'Net Patient Production (Trans. Date)',
      ytd: '$0.00',
      aug: '$0.00',
      jul: '$0.00',
      jun: '$0.00',
      may: '$0.00',
      apr: '$0.00',
      mar: '$0.00',
      feb: '$0.00',
    },
    {
      kpi: 'Net Production (Trans. Date)',
      ytd: '$0.00',
      aug: '$0.00',
      jul: '$0.00',
      jun: '$0.00',
      may: '$0.00',
      apr: '$0.00',
      mar: '$0.00',
      feb: '$0.00',
    },
    {
      kpi: 'Production Adjustment Rate (TXN)',
      ytd: '0.00%',
      aug: '0.00%',
      jul: '0.00%',
      jun: '0.00%',
      may: '0.00%',
      apr: '0.00%',
      mar: '0.00%',
      feb: '0.00%',
    },
  ],
}
export const modalArAgingData = [
  {
    guarantor: 'Anna Philly',
    phone: '690-000',
    '0-30': '$100.00',
    '31-60': '$100.00',
    '61-90': '$100.00',
    '90plus': '$100.00',
    total: '$100.00',
    insurance: '$100.00',
    patient: '$100.00',
    lastPatPayment: '10/13/2023',
  },
  {
    guarantor: 'Fred Buyco',
    phone: '690-000',
    '0-30': '$100.00',
    '31-60': '$100.00',
    '61-90': '$100.00',
    '90plus': '$100.00',
    total: '$100.00',
    insurance: '$100.00',
    patient: '$100.00',
    lastPatPayment: '10/13/2023',
  },
  {
    guarantor: 'Helen Weibus',
    phone: '690-000',
    '0-30': '$100.00',
    '31-60': '$100.00',
    '61-90': '$100.00',
    '90plus': '$100.00',
    total: '$100.00',
    insurance: '$100.00',
    patient: '$100.00',
    lastPatPayment: '10/13/2023',
  },
  {
    guarantor: 'Jean Libby',
    phone: '690-000',
    '0-30': '$100.00',
    '31-60': '$100.00',
    '61-90': '$100.00',
    '90plus': '$100.00',
    total: '$100.00',
    insurance: '$100.00',
    patient: '$100.00',
    lastPatPayment: '10/13/2023',
  },
  {
    guarantor: 'Joyce Glam',
    phone: '690-000',
    '0-30': '$100.00',
    '31-60': '$100.00',
    '61-90': '$100.00',
    '90plus': '$100.00',
    total: '$100.00',
    insurance: '$100.00',
    patient: '$100.00',
    lastPatPayment: '10/13/2023',
  },
  {
    guarantor: 'Julie Gomez',
    phone: '690-000',
    '0-30': '$100.00',
    '31-60': '$100.00',
    '61-90': '$100.00',
    '90plus': '$100.00',
    total: '$100.00',
    insurance: '$100.00',
    patient: '$100.00',
    lastPatPayment: '10/13/2023',
  },
  {
    guarantor: 'Max Millare',
    phone: '690-000',
    '0-30': '$100.00',
    '31-60': '$100.00',
    '61-90': '$100.00',
    '90plus': '$100.00',
    total: '$100.00',
    insurance: '$100.00',
    patient: '$100.00',
    lastPatPayment: '10/13/2023',
  },
  {
    guarantor: 'Rommel Sanchez',
    phone: '690-000',
    '0-30': '$100.00',
    '31-60': '$100.00',
    '61-90': '$100.00',
    '90plus': '$100.00',
    total: '$100.00',
    insurance: '$100.00',
    patient: '$100.00',
    lastPatPayment: '10/13/2023',
  },
  {
    guarantor: 'Sam Milby',
    phone: '690-000',
    '0-30': '$100.00',
    '31-60': '$100.00',
    '61-90': '$100.00',
    '90plus': '$100.00',
    total: '$100.00',
    insurance: '$100.00',
    patient: '$100.00',
    lastPatPayment: '10/13/2023',
  },
  {
    guarantor: 'Taylor Jones',
    phone: '690-000',
    '0-30': '$100.00',
    '31-60': '$100.00',
    '61-90': '$100.00',
    '90plus': '$100.00',
    total: '$100.00',
    insurance: '$100.00',
    patient: '$100.00',
    lastPatPayment: '10/13/2023',
  },
]
